export default __webpack_public_path__ + "static/media/9783986100025.fb476e1e.webp";